import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Toast } from "./../UI/toast/Toast";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../../actions/authActions";
import { getErrorMessage } from "../../helpers/errors/handleErrorMessage";
import {
  isTooManyRequests,
  notifyTooManyRequests,
} from "../../helpers/errors/tooManyRequests";
import Loader from "../common/Loader";

const LoginForm = ({ setRedirectUrl, setRedirect, hasLabel, layout }) => {
  const { isLogged, isLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  // HO-TASK-297: segundos que faltan para poder reintentar tras un 429.
  const [retryIn, setRetryIn] = useState(0);

  const { errors } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (retryIn > 0) return;
    dispatch(Login({ username, password }));
  };

  useEffect(() => {
    setIsDisabled(!username || !password);
  }, [username, password]);

  useEffect(() => {
    setRedirectUrl(`/dashboard/app`);
  }, [setRedirectUrl]);

  useEffect(() => {
    if (isLogged) {
      setRedirect(true);
    }
  }, [isLogged, setRedirect]);

  useEffect(() => {
    if (errors === null) return;

    if (isTooManyRequests(errors)) {
      notifyTooManyRequests(errors);
      if (errors.retry_after > 0) {
        setRetryIn(Math.ceil(errors.retry_after));
      }
      return;
    }

    Toast.fire({
      type: "error",
      title: getErrorMessage(errors?.code),
    });
  }, [errors]);

  useEffect(() => {
    if (retryIn <= 0) return;
    const timer = setTimeout(() => setRetryIn((seconds) => seconds - 1), 1000);
    return () => clearTimeout(timer);
  }, [retryIn]);

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          {hasLabel && <Label>Correo electrónico</Label>}
          <Input
            placeholder={!hasLabel ? "Correo electrónico" : ""}
            value={username}
            onChange={({ target }) => setUsername(target.value)}
          />
        </FormGroup>
        <FormGroup>
          {hasLabel && <Label>Contraseña</Label>}
          <Input
            placeholder={!hasLabel ? "Contraseña" : ""}
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            type="password"
          />
        </FormGroup>
        <div className="text-center">
          <Link
            className="fs--1 d-block"
            to={`/authentication/forget-password`}
          >
            ¿Olvidaste tu contraseña?
          </Link>
          <Link className="fs--1 d-block" to={`/authentication/validate-mail`}>
            ¿Ya estás registrado? Verifica tu cuenta.
          </Link>
        </div>
        <FormGroup>
          {!isLoading ? (
            <Button
              color="primary"
              block
              className="mt-3"
              disabled={isDisabled || retryIn > 0}
            >
              {retryIn > 0 ? `Espera ${retryIn} s` : "Iniciar"}
            </Button>
          ) : (
            <Loader />
          )}
        </FormGroup>
      </Form>
    </>
  );
};

LoginForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
};

LoginForm.defaultProps = {
  layout: "basic",
  hasLabel: false,
};

export default withRedirect(LoginForm);
